import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { getActiveTenantId } from "@/shared/tenant/active-tenant";
import type { DashboardSummary, DashboardWindow } from "./types";

/** GET /api/dashboard — tenant-wide analytics rollup for the landing (ADR-0021). */
export function useDashboard(window: DashboardWindow) {
  return useQuery({
    // window is part of the key so each toggle position is cached independently.
    queryKey: ["dashboard", getActiveTenantId(), window] as const,
    queryFn: () => httpClient<DashboardSummary>(`/api/dashboard?window=${window}`),
  });
}
